import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";
import { CouponImportAccessRights } from "src/coupon-imports/enums/CouponImportAccessRights";

export const CouponGroupAccessRight = {
  VIEW_COUPON_GROUPS: CouponImportAccessRights.VIEW_COUPON_IMPORT,
  DEACTIVATE_COUPON_GROUP: ({ menuDisplayLevel }) => menuDisplayLevel <= 2,
} satisfies Record<string, AuthenticationAccessRight>;
